import {
  CustomerDeactivationModalKey,
  CustomerDetailsKey,
  CustomerListPageKey,
  CustomerListTableKey,
  CustomerPendingListTableKey,
  CustomerUploadModalKey
} from '../../TModules';

export const translations = {
  [CustomerListTableKey]: {
    Identifier: 'Identifier',
    Name: 'Name',
    Status: 'Status',
    DateJoined: 'Date Joined',
    Actions: 'Actions',
    SearchCustomers: 'Search Customers',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
    Active: 'Active',
    Inactive: 'Inactive',
    Initial: 'Initial'
  },

  [CustomerUploadModalKey]: {
    HandleUpload: {
      SuccessMessage: 'File uploaded',
      ErrorMessage: 'Error uploading file.',
      Title: 'Upload Customer File',
      OkText: 'Upload',
      CancelText: 'Cancel',
      UploadButton: 'Upload',
      UploadDraggerMessage: 'Click or drag file to this area to upload',
      DownloadSample: 'Download Sample',
      AcceptedFormat: 'Accepted Format: .txt., .xlsx or.csv files only'
    }
  },
  [CustomerPendingListTableKey]: {
    RequestId: 'Request ID',
    Customer: 'Customer',
    RequestType: 'Request Type',
    Status: 'Status',
    Comment: 'Comment',
    LastUpdated: 'Last Updated',
    DateOfExpiry: 'Date of expiry',
    Actions: 'Actions',
    Comments: 'Comments',
    ViewDetails: 'View details',
    Approve: 'Approve',
    ApproveRequests: 'Approve requests',
    CustomerStampView: 'Customer Stamp View',
    LoyaltyProgramDetails: 'Loyalty Program Details',
    CustomerGameView: 'Customer Game View',
    CustomerRewardView: 'Customer Reward View',
    ApproveSelectedButton: 'Approve selected',
    ReactivateCustomer: 'Reactivate Customer',
    DeactivateCustomer: 'Deactivate Customer',
    VoidVoucher: 'Void Voucher',
    ModifyVoucher: 'Modify Voucher',
    CashbackIssue: 'Cashback Issue',
    Issue: 'Issue',
    Rewards: 'Rewards',
    Reward: 'Reward',
    Stamps: 'Stamps',
    Gametries: 'Game Tries',
    GameTries: 'Game Tries',
    GAMETRIES: 'GAME TRIES',
    Voucher: 'Voucher',
    LoyaltyPoints: 'Loyalty Points',
    Cashbackissue: 'Cashback Issue',
    Loyaltydelete: 'Loyalty Delete',
    AddProgressPoints: 'Add Progress Points',
    MarkQuestTaskComplete: 'Mark Quest Task Complete',
    IssueInstantReward: 'Issue Instant Reward',
    IssueRaffleTicket: 'Issue Raffle Ticket',
    CustomerProgressPointsPendingView: 'Progress Points Pending',
    CustomerQuestTaskPendingView: 'Quest Task Pending',
    CustomerInstantRewardPendingView: 'Instant Reward Pending',
    CustomerRaffleTicketPendingView: 'Raffle Ticket Pending',

    ApproveMultipleMessageModal: {
      SuccessMessage: 'Uploads approved',
      FailureMessage: 'Error approving file.',
      Title: 'Approve multiple requests?',
      OkText: 'Approve selected',
      DescriptionText: `
      Are you sure you want to approve all the selected requests?
      <br />
      Please verify the details before approving as this action cannot be undone.`
    },
    ApproveRequestModal: {
      SuccessMessage: 'Request has been approved',
      FailureMessage: 'Error approving request.',
      Title: 'Approve request?',
      OkText: 'Approve',
      DescriptionText: `Are you sure you want to approve this request?`
    },
    UploadCommentModal: {
      ViewAndAddComments: 'View and add comments',
      Content: 'Content',
      DeleteButton: 'Delete button',
      Time: 'Time',
      ErrorAddingComment: 'Error adding comment',
      CommentAdded: 'Comment added',
      EnterYourCommentHere: 'Enter your comment here',
      AddComment: 'Add comment',
      CommentsAdded: 'Comments added',
      Delete: 'Delete'
    },
    DeleteCommentModal: {
      CommentDeleted: 'Comment deleted',
      ErrorDeletingComment: 'Error deleting comment',
      DeleteComment: 'Delete comment?',
      Delete: 'Delete',
      DescriptionFirstLine: `Are you sure you want to delete your comment?`,
      DescriptionSecondLine: `This action cannot be undone.`
    }
  },
  [CustomerListPageKey]: {
    PendingRequests: 'Pending Requests',
    Customers: 'Customers',
    CustomersList: 'Customers List',
    Upload: 'Upload',
    TransactionRequests: 'Transaction requests',
    DeactivatingCustomer: 'Deactivating customer...',
    DeactivationRequestSubmitted: 'Customer Deactivation Request Submitted For Approval!',
    SuccessfullyDeactivated: 'Successfully deactivated!',
    DeactivationFailed: 'Deactivation failed',
    SuccessfullyDeleted: 'Successfully deleted!',
    DeletingCustomer: 'Deleting customer...',
    ActivatingCustomer: 'Activating customer...',
    ActivationRequestSubmitted: 'Customer Activation Request Submitted For Approval!',
    SuccessfullyActivated: 'Successfully Activated!',
    ActivationFailed: 'Activation failed',
    LoadingCustomer: 'Loading customer...',
    ErrorRetrievingCustomer: 'Something Went Wrong!'
  },
  [CustomerDeactivationModalKey]: {
    ProvideReasonForDeactivation: 'Provide Reason for Deactivation',
    ProvideReasonForActivation: 'Provide Reason for Activation',
    Deactivate: 'Deactivate',
    Activate: 'Activate',
    Cancel: 'Cancel',
    DeactivationReason: 'Please select reason'
  },
  [CustomerDetailsKey]: {
    ID: 'ID',
    CustomerDetails: 'Customer Details',
    RewardsLabel: 'Rewards',
    Identifier: 'Identifier',
    UserInfo: 'User Info',
    FirstName: 'First Name',
    MiddleName: 'Middle Name',
    LastName: 'Last Name',
    Gender: 'Gender',
    Address: 'Address',
    Birthday: 'Birthday',
    JoinedAt: 'Joined At',
    CreatedVia: 'Created Via',
    ReferralCode: 'Referral Code',
    Email: 'Email',
    Phone: 'Phone',
    State: 'State',
    City: 'City',
    Race: 'Race',
    Segment: 'Segment',
    AccountId: 'Account ID',
    Nationality: 'Nationality',
    AlternateId: 'Alternate ID',
    ProductType: 'Product Type',
    Classification: 'Classification',
    LocationState: 'Location State',
    PreferredLanguage: 'Preferred Language',
    FindRewardByNameTypeOrMerchant: 'Find Reward By Name Type Or Merchant',
    IssueRewards: 'Issue Rewards',
    RewardIssueMakerCheckerErrorMessage: 'You cannot approve your own request',
    RewardIssueErrorMessage: 'Error occurred while issuing rewards',
    RewardIssueErrorsOccurredWhileIssuingRewards: `Errors occurred while issuing rewards`,
    RewardIssueSuccessMessage: 'Reward issued successfully',
    RewardIssueMakerCheckerSuccessMessage: 'Reward issue request submitted for approval',
    RewardIssueUnexpectedResponseFormat: 'Unexpected response format',
    ErrorRetrievingCustomer: 'Error Retrieving Customer',
    CustomerRewards: 'Customer Rewards',
    Stamps: 'Stamps',
    Games: 'Games',
    LoyaltyProgram: 'Loyalty program',
    AccountDetails: 'Account Details',
    ProgressCampaign: 'Progress Campaign',
    Campaigns: 'Campaigns',
    EventLogs: {
      TabLabel: 'Event Logs',
      Filters: {
        EventName: 'Event Name',
        EventNamePlaceholder: 'Select event name',
        Helper: 'Filter the list by event name'
      },
      Table: {
        ID: 'ID',
        EventName: 'Event Name',
        Params: 'Params',
        State: 'State',
        CreatedAt: 'Created At'
      },
      Detail: {
        Title: 'Event Log Detail',
        Back: 'Back to Event Logs',
        RuleOutcomes: 'Rule Outcomes',
        Error: 'Unable to load event log details.',
        NoData: 'Event log not found.',
        Fields: {
          ID: 'ID',
          EventName: 'Event Name',
          State: 'State',
          EventParams: 'Event Params',
          CreatedAt: 'Created At',
          UpdatedAt: 'Updated At',
          ProcessingStartedAt: 'Processing Started At',
          ProcessingCompletedAt: 'Processing Completed At'
        }
      }
    },
    Transactions: {
      TabLabel: 'Transactions',
      Filters: {
        State: 'State',
        StatePlaceholder: 'Select state',
        TransactionReference: 'Transaction Reference',
        TransactionReferencePlaceholder: 'Enter transaction reference',
        CreatedAtRange: 'Created Date Range',
        CreatedAtRangeStartPlaceholder: 'Start date',
        CreatedAtRangeEndPlaceholder: 'End date',
        Helper: 'Filter the list by state, reference, or created date'
      },
      Table: {
        ID: 'ID',
        Reference: 'Reference',
        Amount: 'Amount',
        Properties: 'Properties',
        State: 'State',
        CreatedAt: 'Created At'
      },
      Detail: {
        Title: 'Transaction Detail',
        Back: 'Back to Transactions',
        Error: 'Unable to load transaction details.',
        NoData: 'Transaction not found.',
        RuleOutcomes: 'Rule Outcomes',
        Fields: {
          ID: 'ID',
          Reference: 'Reference',
          Amount: 'Amount',
          State: 'State',
          CreatedAt: 'Created At',
          UpdatedAt: 'Updated At',
          TransactionDate: 'Transaction Date',
          TransactionType: 'Transaction Type',
          Currency: 'Currency',
          ProcessedAt: 'Processed At',
          ProcessAt: 'Process At',
          TransactionStatus: 'Transaction Status',
          UniqueTransactionId: 'Unique Transaction ID',
          UserAccountId: 'User Account ID',
          AmountPoint: 'Amount Point',
          MerchantUserAccountId: 'Merchant User Account ID',
          WorkflowId: 'Workflow ID',
          Properties: 'Properties'
        }
      }
    },
    RuleOutcomesTable: {
      RuleOutcomeId: 'Rule Outcome ID',
      TransactionRuleId: 'Transaction Rule ID',
      TransactionRuleName: 'Transaction Rule Name',
      State: 'State',
      AdditionalInfo: 'Additional Info',
      Empty: 'No rule outcomes available.'
    },
    FilteringChecks: {
      TabLabel: 'Filtering Checks',
      RewardTabLabel: 'Reward Filtering',
      CampaignTabLabel: 'Campaign Filtering',
      HelperText: 'Run a check to see which filters pass or fail for this customer.',
      PassedFilters: 'Passed Filters',
      FailedFilters: 'Failed Filters',
      NoPassedFilters: 'No passed filters',
      NoFailedFilters: 'No failed filters',
      GenericError: 'Customer ID is invalid',
      NotFoundError: '404 not found',
      ToggleHide: 'Hide section',
      ToggleShow: 'Show section',
      Reward: {
        Title: 'Reward Filtering Check',
        Description:
          'Enter a customer ID to see which filters include or exclude this customer for the reward.',
        Placeholder: 'Enter customer ID',
        InputLabel: 'Customer ID',
        Button: 'Check customer filters',
        MissingIdError: 'Please enter a customer ID'
      },
      Campaign: {
        Title: 'Campaign Filtering Check',
        Description:
          'Enter a customer ID to see which filters include or exclude this customer for the campaign.',
        Placeholder: 'Enter customer ID',
        InputLabel: 'Customer ID',
        Button: 'Check customer filters',
        MissingIdError: 'Please enter a customer ID'
      }
    },
    CustomerIDNotFound: 'Customer ID not found',
    DeleteUser: 'Delete User',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
    ACTIVE: 'ACTIVE',
    DeactivationReason: 'Deactivation Reason',
    AddressState: 'Address State',
    AddressCity: 'Address City',
    Company: 'Company',
    EmailTags: 'Email Tags',
    BusinessType: 'Business Type',
    INACTIVE: 'INACTIVE',
    Cashback: 'Cashback',

    Name: 'Name',
    Status: 'Status',
    Tenure: 'Tenure',
    Tier: 'Tier',
    Balance: 'Balance',
    ToNextTier: 'To Next Tier',
    MembershipExpiry: 'Membership Expiry',

    CashbackModal: {
      CancelIssuanceModal: {
        Title: 'Cancel Issue Cashback Request?',
        MessageLineOne: 'The issue request is pending approval. Are you sure you want to cancel it?'
      },
      ApproveIssuanceModal: {
        Title: 'Approve Cashback Issue',
        MessageLineOne:
          'Are you sure you want to approve this issuance of cashback? This action cannot be undone.'
      }
    },

    Rewards: {
      FindRewardByNameTypeOrMerchant: 'Find reward by name, type or merchant',
      IssueRewardsManually: 'Issue Rewards Manually',
      Issued: 'Issued',
      Pending: 'Pending',
      GiftedAway: 'Gifted Away',
      Redeemed: 'Redeemed',
      RedemptionInProgress: 'Redemption In Progress',
      FullyRedeemed: 'Fully Redeemed',
      Voided: 'Voided',
      Expired: 'Expired',
      Archived: 'Archived',

      Name: 'Name',
      DeletionRequested: 'Deletion Requested',
      ID: 'ID',
      RequestType: 'Request Type',
      Merchant: 'Merchant',
      DateOfIssued: 'Date of Issued',
      ValidFrom: 'Valid From',
      ValidTo: 'Valid To',
      VoucherCode: 'Voucher Code',
      AdminFee: 'Admin Fee',
      Action: 'Action',
      DateOfExpired: 'Date of expired',
      DateOfGifted: 'Date of gifted',
      DateOfRedeemed: 'Date of redeemed',
      RequestId: 'Request ID',
      Status: 'Status',
      RewardId: 'Reward ID',
      IssuedOn: 'Issued on',

      VoidVoucher: 'Void Voucher',
      ChangeExpiryDate: 'Change Expiry Date',
      AmendReward: 'Amend Reward',
      UndoRedeem: 'Undo Redeem',
      ThereIsNoActionForGiftedVoucher: 'There is no action for gifted voucher.',
      RevertBackToIssued: 'Revert back to issued',
      WaiveAdminFee: 'Waive Admin Fee',
      DeleteReward: 'Delete Reward',

      CancelVoidRequest: 'Cancel Void Request',
      CancelUpdateRequest: 'Cancel Update Request',
      CancelIssueRequest: 'Cancel Issue Request',

      ViewComments: 'View comments',
      ApproveIssue: 'Approve issue',

      ViewAndAddComments: 'View and add comments',
      RequestHasBeenApproved: 'Request has been Approved',
      ErrorApprovingRewards: 'Error approving rewards.',
      SomethingWentWrong: 'Something Went Wrong',
      HandleUndoRedeemErrorMessage:
        'Cannot undo redemption - please change the expiry date and try again.',
      HandleUndoRedeemConfirmModalTitle: 'Confirm',
      HandleUndoRedeemConfirmModalMessage:
        'This will revert the voucher state back to Issued - continue?',

      HandleVoidVoucherMakerCheckerSuccessMessage: 'Voiding request submitted for approval',
      HandleVoidVoucherSuccessMessage: 'Voucher is voided',
      HandleVoidVoucherConfirmModalMakerCheckerRightButtonText: 'Request voiding',
      HandleVoidVoucherConfirmModalRightButtonText: 'Confirm',
      HandleVoidVoucherConfirmModalMakerCheckerTitle: 'Submit voiding request?',
      HandleVoidVoucherConfirmModalTitle: 'Confirm',
      HandleVoidVoucherConfirmModalMakerCheckerMessage:
        'Are you sure you want to request the voiding of the reward voucher? Once approved, you will not be able to restore it.',
      HandleVoidVoucherConfirmModalMessage: 'This will void the reward voucher - continue?',

      HandleRevertRedemptionToIssuedConfirmModalTitle: 'Confirm',
      HandleRevertRedemptionToIssuedMessageConfirmModalMessage:
        'This will update the voucher state back to Issued - continue?',

      ShowOCBCDemoConfirmModalTitle: 'Confirm',
      ShowOCBCDemoConfirmModalMessage: 'This will waive the admin fee - continue?'
    },

    IssueRewardsModal: {
      Title: 'Issue Rewards Manually',
      OkText_one: 'Issue {{count}} Reward',
      OkText_other: 'Issue {{count}} Rewards',
      SearchPlaceholder: 'Find reward by name, type or merchant',
      ActiveTabLabel: 'Active',
      PrivateTabLabel: 'Private',
      CancelText: 'Cancel',

      CustomerRewardsConfirmationModal: {
        RewardName: 'Reward Name',
        RewardPrices: 'Reward Prices',
        FreeOrPaid: 'Free/Paid',
        ConfirmSellPrice: 'Confirm Sell Price',
        And: 'and',
        Points: 'points',
        Or: 'OR',
        Paid: 'Paid',
        Free: 'Free',
        Cancel: 'Cancel',
        IssueRewards: 'ISSUE REWARDS'
      }
    },
    IssueRewardsTable: {
      Name: 'Name',
      Merchant: 'Merchant',
      ValidityPeriod: 'Validity Period',
      Balance: 'Balance'
    },
    AuditLog: {
      Title: 'Audit Log',
      LastUpdatedAt: 'Last Updated At',
      IpAddress: 'IP Address',
      User: 'User',
      Action: 'Action',
      Description: 'Description',
      RenderSummaryIsCreated: 'created',
      RenderSummaryIsUpdated: 'updated',
      Details: 'Details',
      Old: 'Old',
      New: 'New',
      Audience: {
        Created: 'Audience created',
        NameUpdated: 'Audience name updated',
        FiltersUpdated: 'Filter customers updated',
        FileUploaded: 'Audience File uploaded',
        FileRemoved: 'Audience File removed',
        FileRelationChanged: 'Audience File relation changed',
        Uploaded: 'uploaded',
        Removed: 'removed',
        RelationChangedTo: 'relation changed to',
        NameLabel: 'Audience name',
        Criteria: {
          Age: 'Age',
          Gender: 'Gender',
          CustomAttributes: 'Custom Attributes'
        },
        AttributeGroup: 'Customer attributes',
        AttributeGroupRaw: 'Customer attributes (excluded group)'
      },
      DetailsColumn: {
        AutoFillStamps: 'Auto Fill Stamps',
        Wedges: 'Wedges',
        LandingPage: 'Landing Page',
        EnrolmentType: 'Enrolment Type',
        AutoEnrolUsers: 'Auto Enrol Users',
        State: 'State',
        NameEn: 'Name en',
        Ordering: 'Ordering',
        Timezone: 'Timezone',
        StartDate: 'Start date',
        AutoIssueMoves: 'Auto issue moves',
        TypeOfCampaign: 'Type of campaign',
        OutcomesPerMove: 'Outcomes per move',
        TypeOfCampaignReferral: 'Type of campaign referral',
        Rewards: 'Rewards',
        PeriodUnits: 'Period Units',
        RewardsOrdering: 'Rewards Ordering',
        NoOfStampsPerRow: 'No Of Stamps Per Row',
        TotalStampsOnCard: 'Total Stamps On Card',
        DisplayPropertiesEn: 'Display Properties En',
        DisplayPropertiesTh: 'Display Properties Th',
        DisplayPropertiesVi: 'Display Properties Vi',
        DisplayPropertiesZh: 'Display Properties Zh',
        NoOfStampsPerColumn: 'No Of Stamps Per Column',
        CampaignIntervalPeriod: 'Campaign Interval Period',
        DisplayPropertiesZhHans: 'Display Properties Zh Hans',
        DisplayPropertiesZhHant: 'Display Properties Zh Hant',

        Header: 'Header',
        CardImage: 'Card Image',
        ButtonText: 'Button Text',
        ThumbnailImage: 'Thumbnail Image',
        ButtonBgColour: 'Button Bg Colour',
        GiftActiveImage: 'Gift Active Image',
        ButtonTextColour: 'Button Text Colour',
        StampActiveImage: 'Stamp Active Image',
        DisplayCampaignAs: 'Display Campaign As',
        GiftInactiveImage: 'Gift Inactive Image',
        ButtonExternalLink: 'Button External Link',
        StampInactiveImage: 'Stamp Inactive Image',
        CardBackgroundImage: 'Card Background Image',
        Cols: 'Cols',
        Rows: 'Rows',
        Tags: 'Tags',
        Labels: 'Labels',
        Referee: 'Referee',
        Categories: 'Categories',
        DescriptionEn: 'Description En',
        TermsAndConditionsEn: 'Terms And Conditions En',
        RefereeTotalRewardLimit: 'Referee Total Reward Limit',
        ClaimPrize: 'Claim Prize',
        StampsAwarded: 'Stamps Awarded',
        Status: 'Status',
        Value: 'Value',
        Operators: 'Operators',
        RuleName: 'Rule Name',
        Body: 'Body',
        MilestonesSuccessImage: 'Milestones Success Image',
        SelectRuleAttribute: 'Select Rule Attribute',
        EndDate: 'End Date',
        GrandPrizeOutcome: 'Grand Prize Outcome',
        RaffleTicketOutcome: 'Raffle Ticket Outcome'
      }
    },
    DeleteCustomerModal: {
      MakesCheckerErrorMessage: 'Implement API integration with maker checker under progress',
      Title: 'Delete User?',
      OkText: 'confirm',
      CancelText: 'Go back',
      DescriptionLineOne: 'Are you sure you want to delete this user?',
      DescriptionLineTwo: 'This action cannot be undone.',
      Name: 'Name:',
      Identifier: 'Identifier:'
    },

    LoyaltyProgramsTable: {
      Name: 'Name',
      Status: 'Status',
      Tenure: 'Tenure',
      Tier: 'Tier',
      Balance: 'Balance',
      ToNextTier: 'To Next Tier',
      MembershipExpiry: 'Membership Expiry',
      Actions: 'Actions'
    },
    LoyaltyProgramDetailsModal: {
      Title: 'Loyalty Program Details',
      CloseButton: 'CLOSE',
      Active: 'Active',
      Pending: 'Pending',
      Actions: 'Actions',
      ActionCancelRequest: 'Cancel Request',
      CancelIssuance: 'Cancel Issuance',
      CancelDeletion: 'Cancel Deletion',
      ActionApproveIssue: 'Approve Issue',
      ActionApproveDeletion: 'Approve Deletion',
      ActionDenyDeletion: 'Deny Deletion',
      ActionComments: 'Comments',
      ActionCommentsModalTitle: 'View and add comments',

      Event: 'Event',
      EventButton: 'Deletion requested',
      Carryforward: 'Carryforward',
      Status: 'Status',
      SubmissionDate: 'Submission Date',
      Points: 'Points',
      ExpiresAt: 'Expires at',
      TransactionId: 'Transaction ID',
      LoyaltyTransactionId: 'Loyalty Transaction ID',
      AmountTransacted: 'Amount Transacted',
      TransactionAmount: 'Transaction Amount',
      TransactionDate: 'Transaction date',
      Date: 'Date',
      TransactionRef: 'Transaction Ref.',
      AwardingTransactionId: 'Awarding Transaction ID',
      Properties: 'Properties',
      Merchant: 'Merchant',
      GlAccountNumber: 'GL Account Number',
      CostCenterId: 'Cost Center Id',
      BranchCode: 'Branch Code',

      ChangeStatus: 'Change Status',
      ChangeTier: 'Change Tier',
      AddOrRemovePoints: 'Add / Remove Points',
      AmountIsRequired: 'Amount is required',
      AmountMustBeNonZero: 'Amount must be non-zero',

      PointsAwarded: 'Points Awarded',

      ChangeStatusForm: {
        Active: 'Active',
        Inactive: 'Inactive',
        Save: 'Save'
      },
      ChangeTierForm: {
        Label: 'Override tier expires on:',
        Save: 'Save'
      },
      PointsForm: {
        SelectGlAccount: 'Select GL Account',
        GlAccountType: 'GL Account Type',
        GlAccountName: 'GL Account Name',
        Message: 'Write a message to go with this points adjustment.',
        AdjustPointsButton: 'Adjust Points',
        GLAccountIdIsRequired: 'GL Account id is required',
        GLAccountTypeIsRequired: 'GL Account Type is required',
        GLAccountNameIsRequired: 'GL Account Name is required'
      },
      UpdateLoyaltyProgramCustomerStateSuccessMessage: 'State updated',
      UpdateLoyaltyProgramCustomerStateErrorMessage: 'something went wrong',
      UpdateLoyaltyProgramCustomerTierSuccessMessage: 'Tier updated',
      UpdateLoyaltyProgramCustomerTierErrorMessage: 'something went wrong',
      CreateCustomerLoyaltyTransaction: {
        GLAccountTypeRequiredMessage: 'GL Account Type is required',
        GlAccountNameRequiredMessage: 'GL Account Name is required',
        MakerCheckerSuccessMessage: 'Points issue request submitted for approval',
        SuccessMessage: 'Transaction added',
        ErrorMessage: 'something went wrong'
      },
      DeleteCustomerRequestLoyaltyTransaction: {
        SuccessMessage: 'Request has been cancelled',
        ErrorMessage: 'something went wrong'
      },
      ApproveDenyCustomerRequestLoyaltyTransaction: {
        ApproveSuccessMessage: 'Request has been ',
        RequestHasBeenDeletedMessage: 'Request has been deleted',
        RequestHasBeenApprovedMessage: 'Request has been approved',
        ErrorMessage: 'something went wrong'
      },
      DeleteCustomerLoyaltyTransaction: {
        MakerCheckerSuccessMessage: 'Transaction deletion request submitted for approval',
        SuccessMessage: 'Transaction deleted',
        ErrorMessage: 'something went wrong'
      },
      RecoverCustomerLoyaltyTransaction: {
        SuccessMessage: 'Transaction recovered',
        ErrorMessage: 'something went wrong'
      },
      DeleteCustomerLoyaltyTransactionModal: {
        ActiveTitle: 'Submit deletion request?',
        CancelDeletionTitle: 'Cancel Points Deletion Request?',
        Title: 'Cancel Points Issuance Request?',
        ActiveOkText: 'Request deletion',
        OkText: 'Confirm',
        ActiveCancelText: 'Cancel',
        CancelText: 'Back',
        ActiveMessage:
          'Are you sure you want to request the deletion of these points? Once approved, you will not be able to restore them.',
        MessageLineOne: `The issue of these points is pending approval. Are you sure you want to cancel the request?`,
        MessageLineOneDeletion:
          'The deletion of these points is pending approval. Are you sure you want to cancel it?',
        MessageLineTwo: 'This action cannot be undone.'
      },
      ApproveDenyModal: {
        ApproveIssueTitle: 'Approve loyalty points issue',
        ApproveDeletionTitle: 'Approve Loyalty Points Deletion',
        DenyDeletionTitle: 'Deny loyalty points deletion request',
        DenyDeletionOkText: 'Deny',
        OkText: 'Approve',
        ApproveIssueAndDeletionMessageLineOne: 'Are you sure you want to approve this',
        ApproveIssueAndDeletionMessageLineTwo: 'of loyalty points? This action cannot be undone.',
        Message: `Are you sure you want to deny the deletion of these loyalty points? This action
                    cannot be undone, and the loyalty points will remain active.`,

        Issuance: 'issuance',
        Deletion: 'deletion'
      },

      LineProgressBar: {
        HeaderDateText: 'start of period',
        CustomerTierText: 'The user is currently in',
        Tier: 'Tier',
        CustomerForcedMinimumTierText: 'The user has been forced into minimum',
        CustomerForcedMaximumTierText: `The user has been `,
        FORCED: 'FORCED',
        into: 'into',
        EndOfPeriod: 'end of period',
        ForcedTier: 'Forced tier',
        ForcedMinTier: 'Forced minimum tier',
        UserHasBeen: 'User has been',
        Forced: 'forced',
        To: 'to',
        Status: 'status',
        Until: 'until',
        DeleteForcedTierLinkText: 'X Deactivate Forced Tier',
        ToMinimum: 'to minimum',
        TheUserHasEarned: 'The user has earned',
        Points: 'Point(s)',
        DuringThisCycle: 'during this cycle',
        TheUserRequires: 'The user requires',
        ToLevelUpTo: 'to level up to',
        TheUserHas: 'The user has ',
        Available: 'available.'
      }
    },

    CashbackTable: {
      CashbackTransactionID: 'Cashback Transaction ID',
      Event: 'Event',
      CashbackAmount: 'Cashback Amount',
      Currency: 'Currency',
      Date: 'Date',
      CashbackRuleID: 'Cashback Rule ID',
      TransactionID: 'Transaction ID',
      TransactionAmount: 'Transaction Amount',
      LoyaltyProgramID: 'Loyalty Program ID',
      Points: 'Points',
      IssueCashback: 'Issue Cashback',
      AvailablePoints: 'Available Points',
      NoOfPointsToRedeem: 'No of Points to Redeem',
      Back: 'Back',
      InsufficientPoints: 'Insufficient points balance',
      CashbackMaxError: 'Cannot redeem more than',
      CashbackRuleIDIsRequired: 'Cashback Rule ID is required',
      LoyaltyProgramIDIsRequired: 'Loyalty Program ID is required',
      PointsAreRequired: 'Points are required',
      PointsMustBeANumber: 'Points must be a number',
      PointsMustBeAnInteger: 'Points must be an integer',
      CashbackIssuedSuccessfully: 'Cashback issued successfully',
      IssueCashbackRequestSubmittedSuccessfully:
        'Issue Cashback Request has been submitted successfully.'
    },

    CustomerCampaigns: {
      ID: 'ID',
      HitThePinata: 'Hit The Pinata',
      ScratchCard: 'Scratch Card',
      Plinko: 'Plinko',
      Name: 'Name',
      CampaignType: 'Campaign Type',
      Status: 'Status',
      StartDate: 'Start Date',
      EndDate: 'End Date',
      Actions: 'Actions',
      SearchCampaignsPlaceholder: 'Find a campaign by name or ID',
      UnenrollCustomer: 'Unenroll customer',
      NotStarted: 'Not Started',
      Active: 'Active',
      Completed: 'Completed',
      NotCompleted: 'Not Completed',
      Enrollable: 'Enrollable',
      EndedAndNotEnrolled: 'Ended And Not Enrolled',
      Enrolled: 'Enrolled',
      NotEnrolled: 'Not Enrolled',
      SpinTheWheel: 'Spin The Wheel',
      ShakeTheTree: 'Shake The Tree',
      EnrollCustomer: 'Enroll customer',
      SelectCampaignsPlaceholder: 'Select campaigns',
      EnrollUserSuccessMessage: 'Campaign enrolled',
      UnenrollUserSuccessMessage: 'Campaign unenrolled',
      SomethingWentWrong: 'Something went wrong',
      AddOrRemovePointsButton: 'Add/Remove Points',

      AddOrRemovePointsModal: {
        AdjustProgressCampaignPoints: 'Adjust Progress Campaign Points',
        OkText: 'Adjust Points',
        HowManyPointsToAddOrRemove: 'How many points to add/remove?',
        ReasonForAdjustment: 'Reason For Adjustment',
        PointsCountValidationMessage: 'Please specify a count of points.',
        ReasonToAdjustmentValidationMessage: 'Please specify a reason for adjustment.',
        PointsUpdatedSuccessfully: 'Points updated successfully!',
        ErrorUpdatingPoints: 'Error Updating points'
      },

      SelectedTypeCampaigns: {
        Customers: 'Customers',
        Campaigns: 'Campaigns',
        StampCampaign: 'Stamp Campaign',
        QuizCampaign: 'Quiz Campaign',
        SurveyCampaign: 'Survey Campaign',
        GameCampaign: 'Game Campaign',
        ProgressCampaign: 'Progress Campaign',
        QuestCampaign: 'Quest Campaign',
        InstantRewardCampaign: 'Instant Reward Campaign',
        StreakCampaign: 'Streak Campaign',
        CampaignProgress: 'This customer is currently on'
      },

      RaffleView: {
        TriggerName: 'Trigger Name',
        RaffleRuleID: 'Raffle Rule ID',
        TransactionDetails: 'Transaction Details',
        TransactionRuleID: 'Transaction Rule ID',
        TriggeredDateOrTime: 'Triggered Date',
        RaffleCode: 'Raffle Code',
        State: 'State',
        Reversed: 'Reversed',
        ReversalReason: 'Reversal reason',
        ReversedAt: 'Reversed at',
        ReversedBy: 'Reversed by',
        System: 'System'
      },

      InstantRewardView: {
        TriggerName: 'Trigger Name',
        RuleID: 'Rule ID',
        TransactionDetails: 'Transaction Details',
        TriggeredDateOrTime: 'Completed Date',
        Ref: 'Ref'
      },

      QuestView: {
        TriggerName: 'Trigger Name',
        Task: 'Task',
        QuestRuleID: 'Quest Rule ID',
        TransactionDetails: 'Transaction Details',
        TransactionRuleID: 'Transaction Rule ID',
        TriggeredDateOrTime: 'Triggered Date / Time',
        State: 'State',
        Actions: 'Actions',
        MarkCompleted: 'Mark Completed',
        MarkCompletedSuccessMessage: 'Points updated successfully!',
        MarkCompletedErrorMessage: 'Error Update points'
      },

      CustomerProgressCard: {
        TriggerName: 'Trigger Name',
        ProgressRuleID: 'Progress Rule ID',
        TransactionDetails: 'Transaction Details',
        TransactionRuleID: 'Transaction Rule ID',
        TriggeredDateOrTime: 'Triggered Date / Time',
        Points: 'Points',
        STAGE: 'STAGE',
        ThisCustomerIsCurrentlyOn: 'This customer is currently on',
        FIRST: 'FIRST',
        SECOND: 'SECOND',
        THIRD: 'THIRD',
        FOURTH: 'FOURTH',
        FIFTH: 'FIFTH',
        SIXTH: 'SIXTH',
        SEVENTH: 'SEVENTH',
        EIGHTH: 'EIGHTH',
        NINTH: 'NINTH',
        TENTH: 'TENTH',
        ELEVENTH: 'ELEVENTH',
        TWELFTH: 'TWELFTH',
        THIRTEENTH: 'THIRTEENTH',
        FOURTEENTH: 'FOURTEENTH',
        FIFTEENTH: 'FIFTEENTH',
        SIXTEENTH: 'SIXTEENTH',
        SEVENTEENTH: 'SEVENTEENTH',
        EIGHTEENTH: 'EIGHTEENTH',
        NINETEENTH: 'NINETEENTH',
        TWENTIETH: 'TWENTIETH',
        TWENTYFIRST: 'TWENTY-FIRST',
        TWENTYSECOND: 'TWENTY-SECOND',
        TWENTYTHIRD: 'TWENTY-THIRD',
        TWENTYFOURTH: 'TWENTY-FOURTH',
        TWENTYFIFTH: 'TWENTY-FIFTH',
        TWENTYSIXTH: 'TWENTY-SIXTH',
        TWENTYSEVENTH: 'TWENTY-SEVENTH',
        TWENTYEIGHTH: 'TWENTY-EIGHTH',
        TWENTYNINTH: 'TWENTY-NINTH',
        THIRTITH: 'THIRTIETH',
        THIRTYFIRST: 'THIRTY-FIRST',
        THIRTYSECOND: 'THIRTY-SECOND',
        THIRTYTHIRD: 'THIRTY-THIRD',
        THIRTYFOURTH: 'THIRTY-FOURTH',
        THIRTYFIFTH: 'THIRTY-FIFTH',
        THIRTYSIXTH: 'THIRTY-SIXTH',
        THIRTYSEVENTH: 'THIRTY-SEVENTH',
        THIRTYEIGHTH: 'THIRTY-EIGHTH',
        THIRTYNINTH: 'THIRTY-NINTH',
        FORTIETH: 'FORTIETH',
        FORTYFIRST: 'FORTY-FIRST',
        FORTYSECOND: 'FORTY-SECOND',
        FORTYTHIRD: 'FORTY-THIRD',
        FORTYFOURTH: 'FORTY-FOURTH',
        FORTYFIFTH: 'FORTY-FIFTH',
        FORTYSIXTH: 'FORTY-SIXTH',
        FORTYSEVENTH: 'FORTY-SEVENTH',
        FORTYEIGHTH: 'FORTY-EIGHTH',
        FORTYNINTH: 'FORTY-NINTH',
        FIFTIETH: 'FIFTIETH'
      },

      CustomerGameView: {
        TriesID: 'Tries ID',
        Status: 'Status',
        AcquiredVia: 'Acquired Via',
        ReasonCode: 'Reason Code',
        Email: 'Email',
        ID: 'ID',
        DateOfIssue: 'Date of Issue',
        DateOfExpiry: 'Date of Expiry',
        Outcomes: 'Outcomes',
        VoucherID: 'Voucher ID',
        NoOutcome: 'no outcome',
        SorrySomethingWentWrong: 'Sorry, something went wrong!',
        NoExpiry: 'no expiry',

        All: 'All',
        Issued: 'Issued',
        Redeem: 'Redeem',
        Expired: 'Expired',
        Pending: 'Pending',
        CustomerSupport: 'Customer Support',

        PendingColumns: {
          RequestID: 'Request ID',
          Status: 'Status',
          Reason: 'Reason',
          NumberOfTries: 'Number of tries',
          DateOfRequest: 'Date of request',
          Actions: 'Actions'
        },

        ApproveIssue: `Approve issue`,
        CancelIssuance: 'Cancel Issuance',
        ViewComments: 'View comments',
        ViewAndAddComments: 'View and add comments',

        ApproveIssueSuccessMessage: 'Request has been approved',
        ApproveIssueErrorMessage: 'Something Went Wrong',

        ApproveDenyModal: {
          Title: 'Approve rewards issue',
          OkText: 'Approve',
          CancelText: 'Cancel',
          Description: `Are you sure you want to approve the issuance of this reward? This action cannot be
            undone.`
        }
      },

      CustomerCardView: {
        Slot: 'Slot #',
        StampId: 'Stamp ID',
        Status: 'Status',
        AcquiredVia: 'Acquired via',
        StampIssuedDate: 'Stamp Issued Date',
        StampRedeemedDate: 'Stamp Redeemed Date',
        Outcomes: 'Outcomes',
        RedeemTheStamp: 'Redeem the stamp',
        EmptySlots: 'Empty Slots',
        SlotEmpty: 'Slot Empty',
        ID: 'ID',

        VoucherID: 'Voucher ID',
        RewardID: 'Reward ID',

        NoRewards: 'No rewards issued',
        NoRewardsIssued: 'No rewards issued',
        Note: 'Note',
        Email: 'Email',
        SorrySomethingWentWrong: 'Sorry, something went wrong'
      },

      CustomerQuizAndSurveyView: {
        QuestionNo: 'Question No.',
        Question: 'Question',
        Response: 'Response',
        SubmissionDateOrTime: 'Submission Date / Time',
        Result: 'Result'
      },

      IssueGameChangeModal: {
        MakerCheckerSuccessMessage: 'Game chance issue request submitted for approval',
        SuccessMessage: 'Game chances issued successfully!',
        ErrorMessage: 'Error issuing game chances',
        IssueGameTriesButton: 'Issue Game Tries',
        IssueGameChanceButton: 'Issue Game Chance',
        Title: 'Issue game chance to',
        OkText: 'Issue Chance',
        HowManyChances: 'How many chances?',
        ReasonForIssuance: 'Reason for issuance',

        ChanceCountValidationMessage: 'Please specify a count of chances.',
        ReasonForIssuanceValidationMessage: 'Please specify a reason for issuance.'
      },

      CustomerStampCards: {
        CardHash: 'Card #',
        StampCardID: 'Stamp Card ID',
        State: 'State',
        ExpiryDate: 'Expiry Date',
        DateOfParticipation: 'Date of Participation',
        StampsCollected: 'Stamps Collected',
        CompletedDate: 'Completed Date',
        RewardsAchieved: 'Rewards Achieved',

        PendingColumns: {
          RequestID: 'Request ID',
          State: 'State',
          Reason: 'Reason',
          NumberOfStamps: 'Number of stamps',
          DateOfRequest: 'Date of request',
          Actions: 'Actions'
        },

        CancelIssuance: 'Cancel Issuance',
        ApproveIssue: 'Approve issue',
        ApproveIssueSuccessMessage: 'Request has been approved',
        ApproveIssueErrorMessage: 'Something Went Wrong',
        ViewComments: 'View comments',

        Active: 'Active',
        Completed: 'Completed',
        Expired: 'Expired',
        Pending: 'Pending',

        SorrySomethingWentWrong: 'Sorry, something went wrong'
      },

      IssueStampsModal: {
        MakerCheckerSuccessMessage: 'Stamp issue request submitted for approval',
        SuccessMessage: 'Issue stamps successful!',
        ErrorMessage: 'Error Issuing stamps',
        IssueStampsButton: 'Issue Stamps',
        Title: 'Issue stamps to',
        OkText: 'Issue Stamps',
        CancelText: 'Cancel',
        HowManyStamps: 'How many stamps?',
        ReasonForIssuance: 'Reason for issuance',
        CustomerFullNameDefault: 'Current Customer',

        StampsCountValidationMessage: 'Please specify a count of stamps.',
        ReasonToIssuanceValidationMessage: 'Please specify a reason for issuance'
      },

      DeleteRequestModal: {
        SuccessMessage: 'Request has been cancelled',
        ErrorMessage: 'Something Went Wrong',
        Title: 'Cancel {{type}} Issuance Request?',
        OkText: 'Confirm',
        CancelText: 'Cancel',
        DescriptionLineOne:
          'This {{lowerCaseType}} is pending approval. Are you sure you want to cancel it?',
        DescriptionLineTwo:
          'Once the cancellation is approved, this {{lowerCaseType}} will not be available and you will need to create it again.'
      },

      IssueRewardModal: {
        RewardIssuedSuccessfully: 'Reward issued successfully!',
        ErrorIssueReward: 'Error Issue reward',
        IssueRewardTitle: 'Issue Rewards',
        IssueRewardOkText: 'Issue Reward',
        IssueRewardButton: 'Issue Reward',
        ReasonForAdjustment: 'Reason For Adjustment',
        PleaseSpecifyAReasonForAdjustment: 'Please specify a reason for adjustment'
      },

      ProgressPointsPendingView: {
        RequestID: 'Request ID',
        Status: 'Status',
        Reason: 'Reason',
        NumberOfPoints: 'Number of points',
        DateOfRequest: 'Date of request',
        Actions: 'Actions',
        ApproveRequest: 'Approve request',
        CancelIssuance: 'Cancel Issuance',
        ViewComments: 'View comments',
        ViewAndAddComments: 'View and add comments',
        ApproveRequestSuccessMessage: 'Request has been approved',
        ApproveRequestErrorMessage: 'Something went wrong',
        Pending: 'Pending',
        Completed: 'Completed',
        All: 'All',
        ApproveDenyModal: {
          Title: 'Approve progress points issue',
          OkText: 'Approve',
          CancelText: 'Cancel',
          Description:
            'Are you sure you want to approve this progress points issuance? This action cannot be undone.'
        }
      },

      QuestTaskPendingView: {
        RequestID: 'Request ID',
        Status: 'Status',
        Task: 'Task',
        Reason: 'Reason',
        DateOfRequest: 'Date of request',
        Actions: 'Actions',
        ApproveRequest: 'Approve request',
        CancelIssuance: 'Cancel Issuance',
        ViewComments: 'View comments',
        ViewAndAddComments: 'View and add comments',
        ApproveRequestSuccessMessage: 'Request has been approved',
        ApproveRequestErrorMessage: 'Something went wrong',
        Pending: 'Pending',
        Completed: 'Completed',
        All: 'All',
        ReasonForCompletion: 'Reason for completion',
        ReasonRequired: 'Please specify a reason',
        ReasonModalTitle: 'Mark Quest Task Complete',
        ReasonModalOkText: 'Submit',
        RequestSubmittedForApproval: 'Request submitted for approval',
        ApproveDenyModal: {
          Title: 'Approve quest task completion',
          OkText: 'Approve',
          CancelText: 'Cancel',
          Description:
            'Are you sure you want to approve this quest task completion? This action cannot be undone.'
        }
      },

      InstantRewardPendingView: {
        RequestID: 'Request ID',
        Status: 'State',
        Reason: 'Reason',
        DateOfRequest: 'Date of request',
        Actions: 'Actions',
        ApproveRequest: 'Approve request',
        CancelIssuance: 'Cancel Issuance',
        ViewComments: 'View comments',
        ViewAndAddComments: 'View and add comments',
        ApproveRequestSuccessMessage: 'Request has been approved',
        ApproveRequestErrorMessage: 'Something went wrong',
        Pending: 'Pending',
        Completed: 'Completed',
        All: 'All',
        RequestSubmittedForApproval: 'Request submitted for approval',
        ApproveDenyModal: {
          Title: 'Approve instant reward issue',
          OkText: 'Approve',
          CancelText: 'Cancel',
          Description:
            'Are you sure you want to approve this instant reward issuance? This action cannot be undone.'
        }
      },

      RaffleTicketPendingView: {
        RequestID: 'Request ID',
        Status: 'Status',
        Reason: 'Reason',
        DateOfRequest: 'Date of request',
        Actions: 'Actions',
        ApproveRequest: 'Approve request',
        CancelIssuance: 'Cancel Issuance',
        ViewComments: 'View comments',
        ViewAndAddComments: 'View and add comments',
        ApproveRequestSuccessMessage: 'Request has been approved',
        ApproveRequestErrorMessage: 'Something went wrong',
        Pending: 'Pending',
        Issued: 'Issued',
        All: 'All',
        RequestSubmittedForApproval: 'Request submitted for approval',
        ApproveDenyModal: {
          Title: 'Approve raffle ticket issue',
          OkText: 'Approve',
          CancelText: 'Cancel',
          Description:
            'Are you sure you want to approve this raffle ticket issuance? This action cannot be undone.'
        }
      },

      AddRemovePointsModal: {
        RequestSubmittedForApproval: 'Request submitted for approval',
        PointsUpdatedSuccessfully: 'Points updated successfully!',
        ErrorUpdatingPoints: 'Error Updating points',
        AddOrRemovePointsButton: 'Add/Remove Points',
        AdjustProgressCampaignPoints: 'Adjust Progress Campaign Points',
        OkText: 'Adjust Points',
        HowManyPointsToAddOrRemove: 'How many points to add/remove?',
        ReasonForAdjustment: 'Reason For Adjustment'
      }
    },

    CustomerStamps: {
      All: 'All',
      Active: 'Active',
      Inactive: 'Inactive',

      Name: 'Name',
      Status: 'Status',
      Started: 'Started',
      Ended: 'Ended',
      ID: 'ID',

      SearchPlaceholder: 'Find a campaign by name',

      EnrollCampaignModal: {
        SuccessMessage: 'Campaign enrolled successful!',
        ErrorMessage: 'Campaign enrolled failed.',
        CampaignIDValidationMessage: 'Please specify a campaign',
        FullNameDefault: 'Current Customer',

        ManualEnrollButton: 'Manual Enroll',
        Title: 'Enroll',
        OkText: 'Enroll Customer',
        CancelText: 'Cancel'
      },

      CampaignSelectField: {
        Label: 'Select Campaign',
        Edit: 'Edit',
        Add: 'Add',
        Campaign: 'Campaign'
      },

      CampaignSelectModal: {
        Title: 'Select a Campaign',
        CancelText: 'Cancel',
        OkText: 'Add Campaign',
        SearchPlaceholder: 'Find a campaign by name, type or merchant',

        Name: 'Name',
        ID: 'ID',
        Status: 'Status',
        Tags: 'Tags',
        StartDate: 'Start Date',
        EndDate: 'End Date',

        Active: 'Active',
        Approved: 'Approved'
      }
    },

    CustomerGames: {
      Name: 'Name',
      ID: 'ID',
      Status: 'Status',
      GameType: 'Game Type',
      TriesRedeemed: 'Tries Redeemed',
      Started: 'Started',
      Ended: 'Ended',
      SearchPlaceholder: 'Find a campaign by name',
      SorrySomethingWentWrong: 'Sorry, something went wrong',

      Tabs: {
        All: 'All',
        Active: 'Active',
        Approved: 'Approved',
        Inactive: 'Inactive',
        Ended: 'Ended'
      }
    }
  }
};
